export enum SealTypes {
    NONE = 0,
    ORIGIN = 1,
    ORGANISM = 2,
    COMPANY = 3,
    COLLEGE = 4,
}
